export default "__VITE_ASSET__DJCAUqkJ__"